import { useTranslation } from "react-i18next";
import { useApiMutation } from "../../../Hooks/useApiMutation";
import { useState } from "react";
import { Spinner } from "../../../Components/LoadingAnimations/LoadingAnimations";
import FormButtons from "../../../Components/Buttons/FormButtons";
import instance from "../../../Interceptor/api_instance";

export const CreateReceiptCharge = ({ close, receiptId, setData, setFeedback }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    description: "",
    amount: "",
  });
  const { mutate, isLoading, error } = useApiMutation(async (e) => {
    e.preventDefault();
    const response = await instance.post(
      `/safety/receipts/${receiptId}/charges/`,
      {
        description: formData.description,
        amount: parseFloat(formData.amount),
      },
    );
    setData(response.data);
    setFeedback({ message: "Charge created successfully", variant: "success" });
    close();
  });
  return (
    <div className="page-mask page-mask-animation">
      <div className="white-cont">
        <form onSubmit={mutate}>
          <h2 className="">Receipt Charge</h2>
          <div className="flex-1">
            <div className="form-block">
              <label>{t("yard-tables.table-columns.description")}</label>
              <div className="input-cont">
                <input
                  type="text"
                  className="text-input with-border"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="form-block">
              <label>{t("yard-tables.table-columns.amount")}</label>
              <div className="input-cont">
                <input
                  type="number"
                  step="0.01"
                  className="text-input with-border"
                  min={0}
                  value={formData.amount}
                  onChange={(e) =>
                    setFormData({ ...formData, amount: e.target.value })
                  }
                />
              </div>
            </div>
          </div>
          {error && <p className="error">{error}</p>}
          <FormButtons onCancel={close} isLoading={isLoading} />
        </form>
      </div>
    </div>
  );
};
